<template>

</template>

<script>
    export default {
        props: ['paused'],
        data() {
            return {
                hover: false
            };
        },
        mounted() {

        },
        methods: {

        }
    }

</script>

<style rel="stylesheet/scss" lang="scss" type="text/css">
    .button {
        & .post-item {
            transition: all 0.1s ease-in-out;
            box-shadow: inset 0 0 0pt 1px theme('colors.primarycolor');

        }
        & .post-item:hover {
            box-shadow: inset 0 0 0pt 3px theme('colors.primarycolor');
            transition: all 0.1s ease-in-out;
        }
        .arrow-down {
            margin-left:10px;
            margin-top:5px;
        }
    }

    //if a button is followed by another button, we decrease margin-top
    .button {
        + .button {
            @apply mt-6;
        }
    }

</style>
